<template>
  <div class="fast-answer d-flex justify-content-end p-3 text-right">
    <button
      v-for="(fast_answer, i) in fast_answers_first"
      :key="`fast-answer-${i}`"
      type="button"
      class="btn btn-light btn-sm mr-2 text-truncate"
      @click.prevent="select(fast_answer)"
    >
      <i class="ri-reply-fill mr-1 text-muted" />
      {{ fast_answer }}
    </button>
    <b-dropdown
      v-if="fast_answers_last.length"
      toggle-class="btn btn-light btn-sm mr-2"
      variant="light"
      dropup
      right
    >
      <template slot="button-content">
        {{ $t('room.footer.fast_answers.more') }}
        <i class="ri-more-fill ml-2 text-muted" />
      </template>
      <b-dropdown-item
        v-for="(fast_answer, i) in fast_answers_last"
        :key="`fast-answer-dropdown-${i}`"
        link-class="text-truncate"
        @click.prevent="select(fast_answer)"
      >
        {{ fast_answer }}
      </b-dropdown-item>
    </b-dropdown>
  </div>
</template>

<script>
export default {
  data: () => ({
    loading: false,
  }),
  computed: {
    fast_answers() {
      return this.$store.state.rooms.setting.fast_answers.map(t => t.trim()).filter(t => !!t.length)
    },
    fast_answers_first() {
      return this.fast_answers.slice(0, 3);
    },
    fast_answers_last() {
      return this.fast_answers.slice(3).reverse();
    },
  },
  methods: {
    select(payload) {
      this.$emit('select', payload);
    },
  },
}
</script>

<style>
.fast-answer .dropdown-menu-right {
  right: auto !important;
}

.fast-answer .dropdown-menu {
  max-width: 300px;
}
</style>
